"use client";

import "@solana/wallet-adapter-react-ui/styles.css";

import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import { ConnectionProvider, WalletProvider } from "@solana/wallet-adapter-react";
import { WalletModalProvider } from "@solana/wallet-adapter-react-ui";
import type React from "react";
import { useMemo } from "react";
import "@solana/wallet-adapter-react-ui/styles.css";

import { clusterApiUrl } from "@solana/web3.js";

import type { SolanaVirtualMachineClusterName } from "@/config/vm-feature-config";

import { useVirtualMachineContext } from "@/subsystems/exchange/virtual-machine-provider";

function getNetwork(_network: SolanaVirtualMachineClusterName) {
  if (_network === "mainnet-beta") {
    return WalletAdapterNetwork.Mainnet;
  }

  if (_network === "testnet") {
    return WalletAdapterNetwork.Testnet;
  }

  return WalletAdapterNetwork.Devnet;
}

export default SolanaProvider;

// https://solana.com/developers/cookbook/wallets/connect-wallet-react
function SolanaProvider({ children }: { children: React.ReactNode }) {
  const { solanaVirtualMachineClusterName } = useVirtualMachineContext();

  // The network can be set to 'devnet', 'testnet', or 'mainnet-beta'
  const network = getNetwork(solanaVirtualMachineClusterName as SolanaVirtualMachineClusterName);

  // You can also provide a custom RPC endpoint
  const endpoint = useMemo(() => clusterApiUrl(network), [network]);

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider autoConnect wallets={[]}>
        <WalletModalProvider>{children}</WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  );
}
